module.exports = __webpack_public_path__ + "media/images/uploadBtnIcon-white-aeb6dff80d6807df9667d3c8bc5cc609.svg";